"use strict";

module.exports = constantL;

function* constantL(a) {
  yield a;
}